const getShareUrl = (shareUrlPrefix: string, pageUrl: string) => {
  return shareUrlPrefix + encodeURI(pageUrl);
};

export default getShareUrl;
